import { render } from "./BaseTablePanel.vue?vue&type=template&id=174d8f84&ts=true"
import script from "./BaseTablePanel.vue?vue&type=script&lang=ts"
export * from "./BaseTablePanel.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2396485125/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__